module.exports = __webpack_public_path__ + "kudos_33.svg?de5b3563957bdfbb2757102f880d16a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_33.svg
// module id = 132
// module chunks = 0